import { render, staticRenderFns } from "./deletedgrnfiledetails.vue?vue&type=template&id=2642f1f5"
import script from "./deletedgrnfiledetails.vue?vue&type=script&lang=js"
export * from "./deletedgrnfiledetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports